import type { MouseEventHandler } from "react";
import { styled } from "@stitches/react";
import { Button, Tooltip } from "@/vendor/Forge/dist";
import { ForgeIconComponent } from "@/vendor/forge-icons/dist/ForgeIconProps";

const Wrapper = styled("div", { display: "flex", alignItems: "center" });

interface Props {
  id: string;
  icon: string | ForgeIconComponent;
  iconTooltip: string;
  text: string;
  textTooltip: string;
  onIconClick: MouseEventHandler<HTMLButtonElement>;
  onMouseLeaveFromIcon?: MouseEventHandler<HTMLButtonElement>;
}

const TextWithIcon = ({
  id,
  icon,
  iconTooltip,
  text,
  onIconClick,
  onMouseLeaveFromIcon,
}: Props) => {
  if (!text) return null;
  return (
    <Wrapper data-testid="test-icon">
      <Tooltip id={`icon-tooltip-${id}`} text={iconTooltip}>
        <Button
          text={text}
          data-testid={id + "-text"}
          variant="tertiary"
          onClick={onIconClick}
          onMouseLeave={onMouseLeaveFromIcon}
        />
      </Tooltip>
      <Tooltip id={`icon-tooltip-${id}`} text={iconTooltip}>
        <Button
          data-testid={id}
          variant="tertiary"
          icon={icon}
          onClick={onIconClick}
          onMouseLeave={onMouseLeaveFromIcon}
        />
      </Tooltip>
    </Wrapper>
  );
};

export default TextWithIcon;
